export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden bg-background-100"
    >
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20manga%20action%20illustration%20with%20dynamic%20speed%20lines%20and%20warm%20amber%20tones%2C%20silhouette%20of%20a%20powerful%20fighter%20in%20motion%20against%20a%20minimalist%20background%20with%20soft%20golden%20light%2C%20Japanese%20comic%20art%20style%2C%20dramatic%20composition%2C%20warm%20red%20and%20ochre%20palette%2C%20abstract%20ink%20wash%20texture%2C%20cinematic%20lighting%2C%20clean%20negative%20space%20on%20left%20for%20text%20placement&width=1800&height=1200&seq=baki-hero-main&orientation=landscape"
        alt="刃牙漫画 - 热血格斗漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-semibold tracking-wider mb-4">
              热血格斗漫画经典
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold text-white leading-tight mb-3">
              刃牙漫画 · 免费全集在线阅读
            </h1>

            <p className="text-white/80 text-base md:text-lg font-medium mb-5 max-w-xl mx-auto lg:mx-0">
              无需充值，即刻畅读
            </p>

            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              收录《范马刃牙》《刃牙道》《刃牙II》《相扑道》等全部刃牙系列漫画，采用下拉式即时阅读体验，无需跳转、无需等待。无论你是在追最新连载还是重温经典篇章，这里都能找到属于你的格斗热血时刻。全部章节免费开放，手机电脑都能看。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-6 text-white/80 text-xs md:text-sm">
              <span className="flex items-center gap-1.5">
                <i className="ri-check-double-line text-accent-400"></i>
                全集收录
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-smartphone-line text-accent-400"></i>
                下拉式阅读
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line text-accent-400"></i>
                完全免费
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                立即开始阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full border border-white/30 transition-all text-sm whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-fire-line"></i>
                查看热门排行
              </a>
            </div>
          </div>

          <div className="hidden lg:flex flex-shrink-0 w-[360px] xl:w-[420px]">
            <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20powerful%20manga-style%20illustration%20of%20a%20muscular%20fighter%20with%20intense%20expression%2C%20dynamic%20action%20pose%2C%20warm%20crimson%20and%20gold%20color%20palette%2C%20Japanese%20comic%20art%20aesthetic%2C%20speed%20lines%20and%20impact%20effects%2C%20dramatic%20lighting%2C%20bold%20ink%20strokes%2C%20fighting%20spirit%20vibe%2C%20clean%20dark%20background%20with%20warm%20accents&width=840&height=1120&seq=baki-hero-poster&orientation=portrait"
                alt="刃牙漫画主题主视觉 - 范马刃牙格斗场景"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}